module.exports = __webpack_public_path__ + "static/media/md-headset.9f827577.svg";